<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div role="status" aria-live="polite" [attr.aria-busy]="isLoading">
  @if (isLoading) {
    <div class="h-screen flex flex-row justify-center">
      <div class="self-center">
        <div class="flex flex-col items-center">
          <div>
            <p-spinner [size]="{ base: 'md', l: 'lg' }"></p-spinner>
          </div>
          <div>
            <p-text [size]="{ base: 'sm', l: 'md' }" align="center">
              {{ labelKey | translate }}
            </p-text>
          </div>
        </div>
      </div>
    </div>
  }
</div>
